const yodleePDFGenerator = (() => {
    let promiseResolve; 
    let promiseReject;

    let widgetPromise = new Promise((resolve, reject) => {
        promiseResolve = resolve;
        promiseReject = reject;
    });
    const yodleePDFGeneratorDefaultConfig = {
        html: {
            header: "<div class=\"yodlee_pdf_header\" style=\"margin-bottom: 20px;float:left;width:100%\">" +
                "<span class=\"left-head\" style=\"float:left;\"><img src=\"images/hsbc-logo.svg\"  style=\"width:121px;\"></span>" +
                "<span class=\"left-head\" style=\"float:right;\"><img src=\"images/logo-b2c.png\"  style=\"width:121px; margin-top:-17px;\"></span>" +
                "</div>",
            table_header: "<div class=\"sub-header-section no-brdr-top\">SUMMARY</div>"
        }
    };
    const main = (obj) => {
        Object.assign(yodleePDFGeneratorDefaultConfig, obj);
        yodleePDFGeneratorDefaultConfig.security_option = !!yodleePDFGeneratorDefaultConfig.body.security ? yodleePDFGeneratorDefaultConfig.body.security : {};
        getTemplate(res => {
            generatePDF(res, yodleePDFGeneratorDefaultConfig.body.class);
        });
    };

    const getTemplate = (callback) => {
        initScript.toggleLoader(true);
        var URI = yodleePDFGeneratorDefaultConfig.widget_service_api;
        const options = initScript.methodWiseOption('POST', {
            // url: yodleePDFGeneratorDefaultConfig.widget_service_api + "/yodlee-pdf" + '?internal=true',
            url: getV2URL(URI, "yodlee-pdf", yodleePDFGeneratorDefaultConfig.slugs),
            data: JSON.stringify(yodleePDFGeneratorDefaultConfig.body),
            headers: {
                'Content-Type': 'application/json'
            }
        }, yodleePDFGeneratorDefaultConfig.security_option);

        HttpRequest(options, (res) => {
            initScript.toggleLoader(false);
            res = responseInterceptor(res);
            callback(res);
        });
    };

    const generatePDF = (template, widgetTableClass) => {
        initScript.getHTMLElementByDelimiter(widgetTableClass).append(template);
        promiseResolve({
            "code": 200,
            "data": template
        });
    };
    return {
        main,
        widgetPromise
    };
})();
